export default "__VITE_ASSET__CZ3Ghv23__"